import React, { useState, useEffect } from "react";
import "./quote.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteRight } from "@fortawesome/free-solid-svg-icons";

const QuoteGenerator = () => {
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");

  useEffect(() => {
    axios
      .get('https://dummyjson.com/quotes/random')
      .then((response) => {
        console.log('Données reçues :', response.data);
        // selon la structure, adapte les champs
        setQuote(response.data.content || response.data.quote);
        setAuthor(response.data.author || response.data.authorName);
      })
      .catch((error) => {
        console.error("Erreur lors de l'appel API :", error);
      });
  }, []);  // dépendances vides : exécuté une fois au montage
  const currentTheme = localStorage.getItem("theme");

  useEffect(() => {
    const projetSelectElement = document.querySelector("quote-generator");

    if (projetSelectElement) {
      if (currentTheme === "light") {
        projetSelectElement.classList.remove("dark-mode-detail-quote");
        projetSelectElement.classList.add("light-mode-detail-quote");
      } else {
        projetSelectElement.classList.remove("light-mode-detail-quote");
        projetSelectElement.classList.add("dark-mode-detail-quote");
      }
    }
  }, [currentTheme]);

  return (
    <div className="quote-generator" id="quote-generator">
      <blockquote>
        <FontAwesomeIcon
          icon={faQuoteRight}
          className="flip-horizontal"
          style={{ color: "#E8B2C4", fontSize: "2rem" }}
        />
        {quote}{" "}
        <FontAwesomeIcon
          icon={faQuoteRight}
          style={{ color: "#E8B2C4", fontSize: "2rem" }}
        />
      </blockquote>

      <div className="author-container">
        <cite>&nbsp; -{author}</cite>
      </div>
    </div>
  );
};

export default QuoteGenerator;
